// extracted by mini-css-extract-plugin
export default {"support_text":"styles_support_text__y0V6m"};